import { useCallback, useEffect, useState } from "react";

const getMountDefaultCols = (uniqueIdentifier, defaultCols, ensureCols = []) => {
    try{
        const colsOnStorage = localStorage.getItem(uniqueIdentifier);

        if (!colsOnStorage) {
            return defaultCols;
        }

        const stored = colsOnStorage.split(',').filter(Boolean);

        if (!ensureCols.length) {
            return stored;
        }

        const migrationKey = `${uniqueIdentifier}__ensured`;

        if (localStorage.getItem(migrationKey)) {
            return stored;
        }

        const missing = ensureCols.filter((col) => !stored.includes(col));
        const next = missing.length ? [...stored, ...missing] : stored;

        localStorage.setItem(uniqueIdentifier, next);
        localStorage.setItem(migrationKey, '1');

        return next;
    }
    catch(e) {
        console.warn(e);
    }

    return defaultCols;
}

const useTableColumnCustomizer = ({
    defaultSelectedCols,
    uniqueIdentifier,
    ensureCols = [],
}) => {
    const [selectedColumns, setSelectedColumns] = useState(
        () => {
            return getMountDefaultCols(
                uniqueIdentifier, 
                defaultSelectedCols,
                ensureCols
            )
        }
    );

    const onColumnsChange = useCallback((col) => {
        if (selectedColumns.includes(col.dataField)) {
            setSelectedColumns((currentState) => {
                const newState = currentState.filter((c) => c !== col.dataField)

                setTimeout(() => {
                    localStorage.setItem(uniqueIdentifier, newState);
                }, 250);

                return newState;
            });
        } else {
            setSelectedColumns((currentState) => {
                const newState = [...currentState, col.dataField];

                setTimeout(() => {
                    localStorage.setItem(uniqueIdentifier, newState);
                }, 250);

                return newState;
            });
        }
    }, [ selectedColumns ]);

    useEffect(() => {
        const colsOnStorage = localStorage.getItem(uniqueIdentifier);

        if (!colsOnStorage) {
            localStorage.setItem(uniqueIdentifier, defaultSelectedCols);
        }
    }, []);

    return {
        onColumnsChange,
        selectedColumns
    }
}

export default useTableColumnCustomizer;